import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcNews = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.25 7.33329C20.2583 7.33329 21.0833 8.15829 21.0833 9.16663V11C21.0833 11.2383 21.0375 11.4583 20.955 11.6691L18.1866 18.1316C17.9116 18.7916 17.2608 19.25 16.5 19.25H8.24996C7.24163 19.25 6.41663 18.425 6.41663 17.4166V8.24996C6.41663 7.74579 6.61829 7.28746 6.95746 6.95746L12.9891 0.916626L13.9608 1.87913C14.2083 2.12663 14.3641 2.47496 14.3641 2.85079L14.3366 3.14413L13.4658 7.33329H19.25ZM4.58329 19.25H0.916626V8.24996H4.58329V19.25Z"
	})
});
export default SvgIcNews;
